import React, {Component} from 'react';

class ThreadbreaksToolTips extends Component {

    constructor(props) {

        super(props);

    }

    renderPayload() {

        const {payload} = this.props;

        if (!payload) return null;

        return payload.map(
            (data, index) => {
                return (
                    <tr key={'payload-' + index} style={{color: data.fill}}>
                        <td className="text-left" style={{paddingRight: 5}}>{data.name}</td>
                        <td className="text-right">{(data.value)}</td>
                    </tr>
                );
            }
        );

    }

    render() {

        const {active} = this.props;

        if (!active) return null;

        const {label} = this.props;
        const payload = this.renderPayload();

        return (
            <div className="custom-tooltip" style={{backgroundColor: "white", padding: "2px"}}>
                <p>{label}</p>

                <table>
                    <tbody>
                        {payload}
                    </tbody>
                </table>
            </div>
        );

    }

}

export default ThreadbreaksToolTips;